import TablePagination from "@material-ui/core/esm/TablePagination";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
export default function Pagination({
  totalResults,
  paginationParams,
  handlePagination,
  rowsPerPageOptions
}) {
  const [currentPage, setCurrentPage] = useState(paginationParams ? paginationParams.offset / paginationParams.max : 0);
  const {
    t
  } = useTranslation();
  const handlePageChange = (event, newPage) => {
    handlePagination(curr => ({
      ...curr,
      offset: curr.max * newPage
    }));
    setCurrentPage(newPage);
  };
  const onRowsPerPageChange = event => {
    handlePagination(curr => ({
      ...curr,
      max: Number(event.target.value),
      offset: 0
    }));
    setCurrentPage(0);
  };
  if (totalResults === 0) return null;
  return /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    count: totalResults,
    page: currentPage,
    onChangePage: handlePageChange,
    onChangeRowsPerPage: onRowsPerPageChange,
    rowsPerPageOptions: rowsPerPageOptions,
    rowsPerPage: paginationParams.max,
    labelDisplayedRows: ({
      from,
      to,
      count
    }) => `${from}-${to} ${t('pagination.of')} ${count !== -1 ? count : `${t('pagination.more_than')} ${to}`}`,
    labelRowsPerPage: `${t('pagination.rows_per_page')}:`
  });
}
Pagination.defaultProps = {
  rowsPerPageOptions: []
};